module.exports = __webpack_public_path__ + "img/Water_Test.70f2b998.png";